import React from 'react';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '../../hooks/useKeycloak';

const HeaderContainer = () => {
  const { logout, userInfo } = useKeycloak();

  const history = useNavigate();
  const { i18n } = useTranslation();

  const handleHomeClick = () => {
    history(`/${i18n.language}/`, { replace: true });
  };

  const logoutUser = () => {
    logout();
  };

  return (
    <Header
      t={i18n.t}
      language={i18n.language}
      user={userInfo}
      onHomeClick={handleHomeClick}
      logout={logoutUser}
    />
  );
};

export default React.memo(HeaderContainer);
